/**
 * User schema validation with Zod
 * @module schemas/user
 */

import { z } from 'zod';
import { GLOBAL_ROLES } from '../constants/roles.js';

/** Global role schema */
export const globalRoleSchema = z.enum(GLOBAL_ROLES);

/** User summary schema */
export const userSummarySchema = z.object({
  id: z.string().uuid(),
  displayName: z.string().min(1).max(255),
  avatarUrl: z.string().url().nullable(),
});

/** User response schema */
export const userResponseSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string().min(1).max(255),
  avatarUrl: z.string().url().nullable(),
  role: globalRoleSchema,
  isActive: z.boolean(),
  lastLoginAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});

/** Auth token response schema */
export const authTokenResponseSchema = z.object({
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
  expiresIn: z.number().int().positive(),
  user: userResponseSchema.partial(),
});

// Type inference
export type GlobalRoleInput = z.infer<typeof globalRoleSchema>;
export type UserSummaryInput = z.infer<typeof userSummarySchema>;
export type UserResponseInput = z.infer<typeof userResponseSchema>;
export type AuthTokenResponseInput = z.infer<typeof authTokenResponseSchema>;
